import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderActionProps } from '../../../../types/headerActionProps'
import { ActionContent } from '../ActionContent'

export const FamilyPlusAction = (props: HeaderActionProps) => {
  const { isFamilyPlusSelected, onClickFamilyPlus } = usePlansContext()

  return (
    <ActionContent
      isSelected={isFamilyPlusSelected}
      onClick={onClickFamilyPlus}
      {...props}
    />
  )
}
